// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintExportStep-cls1_T4P","cls2":"PreprintExportStep-cls2_PB0 PreprintExportStep-cls1_T4P"};